import { combineEpics } from 'redux-observable'

import adeEpics from './Ade/epics'
import awarenessEpics from './Awareness/epics'
import homeEpics from './Home/epics'
import threatProtectionEpics from './ThreatProtection/epics'
import visualDetectionEpics from './VisualDetection/epics'

export default combineEpics(
  homeEpics,
  awarenessEpics,
  visualDetectionEpics,
  threatProtectionEpics,
  adeEpics
)
